/* fabri-enchufe.js — Selector del tipo de enchufe.
   1) Asocia las casillas al formulario de compra (atributo form=) para que la elección
      quede en la línea del kit ("Enchufe: Tipo G · Reino Unido").
   2) Registra el producto "Adaptador de enchufe" del tipo elegido (precio $0) para que
      fabri-preadd.js lo agregue al carrito junto con el kit: una unidad por cada kit.
      El proveedor / la agencia lo ve como una línea más del pedido.
   3) Si el bloque de envío detecta el país por IP más tarde, actualiza la preselección,
      salvo que el cliente ya haya elegido un enchufe a mano. */
(function () {
  if (window.__fabriEnchufe) return;
  window.__fabriEnchufe = true;

  function tipoDe(box, iso) {
    iso = (iso || '').toUpperCase();
    var en = function (attr) { return (box.getAttribute(attr) || '').split(',').indexOf(iso) !== -1; };
    if (en('data-g')) return 'G';
    if (en('data-i')) return 'I';
    if (en('data-a')) return 'A';
    return iso && iso !== 'XX' ? 'C' : null;
  }

  function mensaje(box) {
    var sel = box.querySelector('.fen-input:checked');
    var txt = box.querySelector('.fen-msg-txt');
    if (sel && txt) txt.textContent = sel.getAttribute('data-msg') || '';
  }

  function elegir(box, tipo) {
    if (!tipo || box.dataset.manual === '1') return;
    var input = box.querySelector('.fen-input[data-tipo="' + tipo + '"]');
    if (input && !input.checked) { input.checked = true; mensaje(box); }
  }

  function init(box) {
    if (box.dataset.fenListo === '1') return;
    box.dataset.fenListo = '1';

    var scope = box.closest('.shopify-section') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]');
    // Ojo: form.id no sirve, el formulario tiene un <input name="id"> que lo tapa
    var formId = form && form.getAttribute('id');
    if (formId) {
      box.querySelectorAll('.fen-input').forEach(function (i) { i.setAttribute('form', formId); });
    }

    box.addEventListener('change', function () {
      box.dataset.manual = '1';
      mensaje(box);
    });

    // El bloque de envío (fabri-envio.js) cambia data-iso cuando detecta el país por IP
    var fbe = scope.querySelector('[data-fbe]');
    if (fbe && window.MutationObserver) {
      var aplicar = function () { elegir(box, tipoDe(box, fbe.getAttribute('data-elegido') || fbe.getAttribute('data-iso'))); };
      new MutationObserver(aplicar).observe(fbe, { attributes: true, attributeFilter: ['data-iso', 'data-elegido'] });
      aplicar();
    }
    mensaje(box);
  }

  function initAll() { document.querySelectorAll('[data-fen]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  window.FabriPreAdd = window.FabriPreAdd || [];
  window.FabriPreAdd.push(function (form, scope) {
    var box = scope.querySelector('[data-fen]');
    var sel = box && box.querySelector('.fen-input:checked');
    if (!sel) return [];
    var id = box.getAttribute('data-adp-' + sel.getAttribute('data-tipo').toLowerCase());
    if (!id) return [];
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    return [{ id: id, quantity: qty }];
  });
})();
